import { Tab, Tabs } from "baseui/tabs";
import React from 'react';
import { connect } from 'react-redux';
import { getMaritalStatus } from "../../calculations/userDataTransformer";
import CumulativeGraph from "./CumulativeGraph";
import { CumulativeJointGraph } from "./CumulativeJointGraph";


const CumulativeTableGroup = (props) => {
    const [activeKey, setActiveKey] = React.useState("0");
    return (
        <Tabs
            onChange={({ activeKey }) => {
                setActiveKey(activeKey);
            }}
            activeKey={activeKey}
        >
            <Tab title="Projected Joint Cumulative"><CumulativeJointGraph {...props} /></Tab>
            <Tab title={props.mainUserName + "'s Benefits - Comparison"}><CumulativeGraph type='main' /></Tab>
            {props.maritalStatus === 'married' ? <Tab title={props.spouseUserName + "'s Benefits - Comparison"}><CumulativeGraph type='spouse' /></Tab> : undefined}
        </Tabs>
    );
}

export default connect(state => ({
    mainUserName: state.userData.answers.mainUserName,
    spouseUserName: state.userData.answers.spouseUserName,
    maritalStatus: getMaritalStatus(state.userData.answers)
}), {})(CumulativeTableGroup);